/*jslint node: true */
/*jshint browserify: true */
"use strict";
if(!global._babelPolyfill) {
    require("babel-polyfill");
}
import $ from "jquery";
if(!global.$) {
    global.$ = $;
}

import ComponentRegistry from "Fratello/Common/ComponentRegistry";
import {createFactory} from "react";
import {render} from "react-dom";

window.initializeComponent = (name, props, id) => {
    return render(createFactory(ComponentRegistry.get(name))(props), document.getElementById(id));
};
window.initializeStore = (name, initialValue) => { ComponentRegistry.initializeStore(name, initialValue) };

import "./fratello.jsx";

// toggle
$('.toggle').on('change', function() {
    let toggle = $(this);
    toggle.is(':checked') ? $(toggle.data('target')).show() : $(toggle.data('target')).hide();
});

// toggle-inverse
$('.toggle-inverse').on('change', function() {
    let toggleInverse = $(this);
    toggleInverse.is(':checked') ? $(toggleInverse.data('target')).hide() : $(toggleInverse.data('target')).show();
});

$('.toggle, .toggle-inverse').trigger('change');


/**
 * ------------------------------------------------------------------------
 * Product detail gallery
 * ------------------------------------------------------------------------
 */

$(window).ready(function(){
    let gallery = $('section.product-gallery');
    var limitN = 0; 
    var limitP = 0;

    if(gallery.length) {
        let items = gallery.find('.gallery-item'),
            detail = gallery.find('.gallery-detail'),
            videoDetail = gallery.find('.gallery-modal .modal-body'),
            videoTitle = gallery.find('.gallery-modal .modal-title'),
            zoom = gallery.find('.gallery-modal'),
            zoomImg = zoom.find('img.modal-image'),
            zoomToggle = gallery.find('.gallery-toggle'),
            activeImage = detail.find('img').attr('src'),
            galleryItems = gallery.find('.gallery-items'),
            pagination = gallery.find('.gallery-paging .list-item>a'),
            itemWidth = $(items[0]).width() + 30.5, // itemWidth + padding 
            widthContainer = itemWidth * items.length, // itemWidth * total items 
            counter = 0, 
            currentStatus = gallery.find('.js-current-status'),
            btnClose = zoom.find('.btn-close');

        setVisibleItems(0,3,items);

        btnClose.on('click', function(e) {
            e.preventDefault();
            zoom.toggle();
            videoDetail.html('');
        });

        items.each(function(i) {
            let self = $(this);

            self.find('a').on('click', function(e) {
                e.preventDefault();
                activeImage = $(this).data('path');

                removeActiveClass(items);
                let parent = $(this).closest('.gallery-item');
                if(!parent.hasClass('active')) parent.addClass('active');

                let videoWidget = detail.find('.widget-video');

                if(videoWidget) {
                    videoWidget.remove();
                }

                if($(this).data('type') == 'video') {
                    /*video
                        .find('img')
                        .hide();*/
                    videoDetail.html('<div class="widget-video"><iframe width="560" height="315" src="' + $(this).data('path') + '" frameborder="0" allowfullscreen></iframe></div>');
                    videoTitle.html($(this).attr('data-title'));
                    //zoomToggle.hide();
                    zoom.toggle();
                }
                else {
                    detail
                        .attr('href', activeImage)
                        .find('img')
                        .show()
                        .attr('src', activeImage);

                    zoomToggle.show();
                }

                // check if pagination is active
                if(pagination.length >= 1) {
                    // check if center-item, and reset to correct value
                    let currentItem = $(items[self.index()]),
                        visibleItem = currentItem.attr('data-order');
                    if (visibleItem == 1) {
                        limitN = 1;
                        limitP = 1;
                    } else if (visibleItem == 2) {
                        limitN = 2;
                        limitP = 2;
                    } else {
                        limitN = 0;
                        limitP = 0;
                    }
                    currentStatus.html(self.index()+1);

                    //
                    let tempActiveItem = $(items[getPositionActiveItem(items)]).find('a').attr('data-path');
                    activeImage = tempActiveItem;

                    zoom.on('show.bs.modal', function(e) {
                        zoomImg.attr('src', tempActiveItem);
                    });
                }
            });
        });

        zoom.on('show.bs.modal', function(e) {
            zoomImg.attr('src', activeImage);
        });

        detail.on('click', function(e) {
            e.preventDefault();
            zoomToggle.trigger('click');
        });

        // Set width container
        if(pagination.length >= 1) {
            galleryItems.css('width',widthContainer + 'px');
        }

        pagination.each(function() {
            $(this).on('click', function(e) {
                e.preventDefault();
                let self = $(e.currentTarget),
                    action = self.attr('data-action'),
                    posActiveItem = getPositionActiveItem(items);
                switch(action) {
                    case 'next':
                        if (posActiveItem + 1 >= items.length) {
                            posActiveItem = 0;
                        } else {
                            posActiveItem++;
                        }
                        updateActiveItem(action, posActiveItem, items, itemWidth, pagination);
                        break;
                    case 'prev':
                        if (posActiveItem == 0) {
                            posActiveItem = items.length-1;
                        } else {
                            posActiveItem--;
                        }
                        updateActiveItem(action, posActiveItem, items, itemWidth, pagination);
                        break;
                }
            })
        });
    }

    function updateActiveItem(action,current,items,itemWidth,pagination) {
        let self = $(items[current]),
            type = self.attr('data-type'),
            path = self.find('a').attr('data-path'),
            detail = gallery.find('.gallery-detail'),
            videoDetail = gallery.find('.gallery-modal .modal-body'),
            detailImage = detail.find('img').attr('src'),
            zoom = gallery.find('.gallery-modal'),
            zoomImg = zoom.find('img.modal-image'),
            zoomToggle = gallery.find('.gallery-toggle'),
            currentStatus = gallery.find('.js-current-status'),
            container = gallery.find('.gallery-items'),
            containerOffset = container.position();
        //
        // remove old active class
        removeActiveClass(items);
        // set new active class
        if(!$(items[current]).hasClass('active')) $(items[current]).addClass('active');

        // update active image/video
        let videoWidget = detail.find('.widget-video');

        if(videoWidget) {
            videoWidget.remove();
        }

        if(type == 'video') {
            detail
                .find('img')
                .hide();

            videoDetail.hide('<div class="widget-video"><iframe width="560" height="315" src="' + path + '" frameborder="0" allowfullscreen></iframe></div>');
            zoomToggle.hide();
        }
        else {
            detail
                .attr('href', path)
                .find('img')
                .show()
                .attr('src', path);

            zoom.on('show.bs.modal', function(e) {
                zoomImg.attr('src', path);
            });

            zoomToggle.show();
        }
        // update current status
        currentStatus.html(current+1);

        //
        let orderItem = self.attr('data-order');
        if(action=='next') {
            // next
            limitN = 0;
            limitP++;
            if(limitP > 2) container.css('left', containerOffset.left-itemWidth+'px');
            if(current == 0) {
                container.css('left', 0 + 'px');
                limitP = 0;
                setVisibleItems(current,3,items);
            }
            if(orderItem == undefined && current < items.length && current > 0) {
                current = current - 2;
                setVisibleItems(current,3,items);
            }
        } else {
            // previous
            limitP = 0;
            limitN++;
            if(limitN > 2) container.css('left', containerOffset.left+itemWidth+'px');
            if(current == (items.length-1)) {
                let maxLength = itemWidth * (items.length - 3);
                container.css('left', '-'+maxLength+'px');
                limitN = 0;
                setVisibleItems(current-2,3,items);
            }
            if(orderItem == undefined && current < items.length-1) {
                setVisibleItems(current,3,items);
            }
        }
    }

    function getPositionActiveItem(list) {
        let activeItem = 0;
        for (let i=0; i<list.length; i++) {
            if($(list[i]).hasClass('active')) {
                activeItem = $(list[i]).index();
            }
        }
        return activeItem;
    }

    function removeActiveClass(list) {
        list.each(function() {
            if($(this).hasClass('active')) $(this).removeClass('active');
        });
    }

// set visible columns
    function setVisibleItems(currentPos,numberOfColumns,items) {
        // remove all dataAttributes
        for(let i=0; i<items.length; i++) {
            $(items[i]).removeAttr('data-order');
        }
        // set visible items
        let counter = 0;
        for(let i=currentPos; i<items.length; i++) {
            if(counter<numberOfColumns) {
                let item = $(items[i]);
                item.attr('data-order',counter);
                counter++;
            }
        }
    }
});

//
// Toggle fields customer forms checkboxes (registration)
//

let toggleCustomerNr = $('.js-customer-number'),
    toggleCustomerType = $('.js-customer-type'),
    toggleVatLiable = $('.js-vatLiable');

if(toggleCustomerNr.length) {
    let customerfield = $('.js-customerNr-toggle');
    toggleCustomerNr.each(function(){
        let toggle = $(this);
        if(toggle.is(':checked') && toggle.val() == 1) {
            // if checked
            if(!customerfield.hasClass('active')) customerfield.slideDown(function(){
                customerfield.addClass('active');
            });
        }
    });
    toggleFields(toggleCustomerNr,customerfield,1);
}

if(toggleCustomerType.length) {
    let cfield = $('.js-customerType-toggle');
    toggleCustomerType.each(function(){
        let toggle = $(this);
        if(toggle.is(':checked') && toggle.val() == 'b2b') {
            // if checked
            if(!cfield.hasClass('active')) cfield.slideDown(function(){
                cfield.addClass('active');
            });
        }
    });
    toggleFields(toggleCustomerType,cfield,'b2b');
}

if(toggleVatLiable.length) {
    let cfield = $('.js-vatLiable-toggle');
    toggleVatLiable.each(function(){
        let toggle = $(this);
        if(toggle.is(':checked') && toggle.val() == 1) {
            // if checked
            if(!cfield.hasClass('active')) cfield.slideDown(function(){
                cfield.addClass('active');
            });
        }
    });
    toggleFields(toggleVatLiable,cfield,1);
}

function toggleFields(field,toggleField,activeVal) {
    field.on('change', function(e) {
        let input = $(e.currentTarget);
        if(input.is(':checked') && input.val() == activeVal) {
            // show
            if(!toggleField.hasClass('active')) toggleField.slideDown(function(){
                toggleField.addClass('active');
            });
        } else {
            // hide
            if(toggleField.hasClass('active')) toggleField.slideUp(function(){
                toggleField.removeClass('active');
            });
        }

    });
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/website.jsx